import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Sticky } from 'react-sticky';

import styles from './styles.module.styl';
import TalkBubble from './talk_bubble.svg';

const StickyHeader = ({
  title
}) => (
  <Sticky disableCompensation>
    {({ isSticky }) => (
      <div className={cx(styles.stickyNav, { [styles.isSticky]: isSticky })}>
        <div className={cx(styles.container, 'container')}>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.buttons}>
            <a
              href="https://auth0.com/get-started?place=header&type=button&text=talk%20to%20sales"
              className={`${styles.btn} btn btn-primary`}
            >
              <TalkBubble />
              Talk to Sales
            </a>
          </div>
        </div>
      </div>
    )}
  </Sticky>);

StickyHeader.propTypes = {
  title: PropTypes.string.isRequired
};

export default StickyHeader;
